// i18n area 'vms' — locale tr-TR (task #171, onda 5): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/vms.tr-TR.meta.json.
import type { enUS } from './vms'

export const trTR: typeof enUS = {
  vms: {
    spof: {
      title: 'Düğümden bağımsızlık',
      single: 'Tek hata noktası',
      alternativesNow: 'Şu anki alternatifler',
      structural: 'Yapısal olarak',
      binding: 'Bağlayıcı kısıt',
      movableNow: 'Şimdi taşınabilir',
    },
    title: 'Sanal makineler',
    migratingChip: 'Geçiş yapılıyor',
    templateChip: 'Şablon',
    expendableTooltip: 'Bozulmuş bir kümede ilk durdurulanlar arasındadır ve bir düğüm kaybından sonra yeniden başlamayabilir.',
    expendableHaTooltip: "Küme sağlıklı olduğu sürece her zaman yeniden başlatılır; bozulmuş bir kümede korumalı VM'ler önce gelir — durdurulabilir ya da küme yeniden bütünleşene kadar kapalı kalabilir, sonra kendiliğinden geri döner.",
    viewDetails: 'Ayrıntıları gör',
    profileLegacy: 'Diğer OS',
    hugePagesNone: 'Yok — normal bellek',
    hugePages2M: "2 MiB'lik sayfalar",
    hugePages1G: "1 GiB'lik sayfalar",
    searchPlaceholder: 'Ada göre ara',
    name: 'Ad',
    vcpus: 'vCPU',
    memory: 'Bellek',
    ipAddresses: 'IP adresleri',
    noIp: 'IP yok',
    authorityNode: 'Authority',
    authorityNextStart: 'bir sonraki başlatmada atanır',
    scope: 'Scope',
    empty: 'Sanal makine yok',
    loadError: 'Sanal makineler yüklenemedi — TVirt arka ucu erişilebilir mi?',
    filterOverlay: 'overlay ağı',
    filterDisk: 'disk',
    filterImage: 'görüntü',
    filteredBy: 'Şuna göre filtrelendi: {kind}',
    filterPhase: 'Aşama',
    filterProtection: 'Koruma',
    filterAll: 'Tümü',
    filterScopePlaceholder: "Scope'a göre filtrele",
    filtersToggle: 'Filtreler',
    scopeTree: {
      title: "Scope'lar",
      all: 'Tüm küme',
      noChildren: 'Burada alt scope yok',
      recursive: "Alt scope'ları da dahil et",
      collapse: 'Scope panelini daralt',
      up: 'Bir üst düzeye çık',
      countTooltip: "Bu scope'ta {direct} VM · alt scope'larla birlikte {total}"
    },
    isoPicker: {
      catalog: 'Katalog',
      unknownCatalog: 'Görünür katalogların dışında',
      noIsos: 'Bu katalogda hazır ISO görüntüsü yok'
    },
    actionsHeader: 'Eylemler',
    templatesTab: {
      quickDeploy: 'QuickDeploy',
      hardware: 'Donanım',
      tags: 'Etiketler',
      age: 'Yaş',
      disk: 'disk',
      disks: 'disk',
      empty: "Şablon yok — kapalı bir VM'yi şablon olarak işaretleyin ya da bir VM'yi şablon olarak klonlayın.",
      clone: 'Klonla / dağıt',
      editTags: 'Etiketleri düzenle',
      exportAction: 'Kataloğa dışa aktar (.tvtpl)',
      exportTitle: 'Kataloğa dışa aktar',
      exportSubmit: 'Dışa aktar',
      exportError: 'Dışa aktarma başarısız',
      exportHint: "Şablon, seçilen katalogda yeni bir VM Şablonu dosyası olarak bir .tvtpl arşivine (donanım manifesti + qcow2'ye düzleştirilmiş her disk) paketlenir. NIC'ler, CD/DVD ortamları ve cloud-init taşınmaz — biçimin spesifikasyonu her bilinçli eksikliği listeler.",
      exportName: 'Dosya adı',
      exportNameHint: 'Boş = <template>-export-<n>',
      exportStorageDefault: 'Şablonun meta veri depolaması',
      importAction: 'Katalogdan içe aktar',
      importTitle: 'Katalogdan içe aktar',
      importHint: 'Seçilen kataloğun ready durumundaki bir VM Şablonu dosyası envanterin bir şablonu olur: dosyanın biçimi (tvtpl, ova, ovf ya da çıplak qcow2) nasıl içe aktarılacağına tek başına karar verir — siz yalnızca dosyayı seçersiniz.',
      importFile: 'Katalog dosyası',
      importFileHint: 'Yalnızca ready dosyalar içe aktarılır — karşıya yüklemesi yarıda olan bir dosya içe aktarılamaz',
      importNoFiles: 'Bu katalogda ready VM Şablonu dosyası yok — önce bir tane karşıya yükleyin veya dışa aktarın'
    },
    templateDetail: {
      quickDeploy: 'QuickDeploy uyumluluğu',
      quickDeployNone: 'Bildirilmemiş',
      quickDeployHint: 'Yalnızca golden imaj cloud-init (Linux) ya da sysprep /generalize sonrası cloudbase-init (Windows) içeriyorsa bildirin: platform bildirime güvenir ve konuğun içine asla bakmaz.',
      notFound: 'Şablon bulunamadı',
      frozen: "Donanım yapılandırması donduruldu: değiştirmek için şablonu VM'ye geri dönüştürün. Ad, notlar ve etiketler düzenlenebilir kalır.",
      storage: 'Depolama',
      size: 'Boyut',
      configTitle: 'Yapılandırma (dondurulmuş)',
      usbClasses: 'Gereken USB sınıfları',
      gpuClasses: 'Gereken GPU sınıfları'
    },
    sharedDisksTab: {
      title: 'Paylaşılan diskler',
      sharing: 'Paylaşım',
      sharingNone: 'Tek bağlantı',
      sharingMultiwriter: 'Paylaşımlı yazma (multiwriter)',
      sharingReadonly: 'Paylaşımlı salt okunur',
      usedBy: 'Kullanan',
      attachedTo: 'Bağlı olduğu',
      notAttached: 'Hiçbir VM\'ye bağlı değil',
      changeSharing: 'Paylaşım kipini değiştir',
      changeSharingTitle: 'Paylaşım kipi',
      changeSharingLocked: 'Kip yalnızca diski hiçbir VM kullanmıyorken değişir',
      sharingChanged: 'Paylaşım kipi güncellendi.',
      lun: 'Tam LUN',
      lunNumber: 'LUN / namespace',
      lunWwn: 'WWN',
      lunSerial: 'Seri numarası',
      antiAffinityWarning: 'İki veya daha fazla üye anti-afinite kuralı olmadan aynı düğümde çalışıyor: bir düğümün arızası hepsini düşürür',
      antiAffinityCreate: 'Kuralı oluştur',
      createSourceLun: 'Hedefin tam bir LUN\'unu devral',
      createLunNumber: 'LUN numarası (NVMe\'de namespace kimliği)',
      createLunHint: 'Hiçbir şey ayrılmaz: boyut devralmada aygıttan okunur',
      noPr: 'Bu sürümde SCSI-3 persistent reservation yok: klasik paylaşılan diskli bir Windows Failover Cluster doğrulanmamıştır; ağ üzerinden koordine olan kümeler (GFS2/OCFS2, RHEL HA, paylaşılan diskli veritabanları) doğrulanmıştır'
    },
    unusedDisksTab: {
      title: 'Kullanılmayan diskler',
      attach: "Bir VM'ye tak",
      attachTitle: "Bir VM'ye tak",
      vm: 'Sanal makine',
      noVms: 'Kullanılabilir VM yok',
      noSlots: "Bu VM'de boş slot yok",
      create: 'Disk oluştur',
      createTitle: 'Disk oluştur',
      createSourceBlank: 'Boş disk',
      createSourceImage: 'Katalogdaki bir görüntüden',
      createImage: 'Görüntü',
      createImageEmpty: 'Görünür kataloglarda hazır bir VM şablonu görüntüsü yok',
      createSizeFromImageHint: 'Görüntünün sanal boyutuyla önceden dolduruldu — yalnızca büyüyebilir',
      convert: 'VM şablonuna dönüştür…',
      convertOnlyQcow2: 'Yalnızca qcow2 diskler dönüştürülür — raw, kaydedilebilir bir şablon biçimi değildir',
      convertTitle: 'VM şablonuna dönüştür',
      convertSubmit: 'Dönüştür (diski yok eder)',
      convertError: 'Dönüştürme başlatılamadı',
      convertWarning: 'YIKICI: disk, seçilen katalogda bir VM şablonu dosyası olur — aynı depolama, sıfır bayt kopyalanır — ve disk olarak VAROLMAYI BIRAKIR. Şablondan yeni bir disk oluşturmak dışında geri dönüş yoktur.',
      convertNameHint: 'Katalog dosyasının adı — varsayılanı diskin kendi adıdır',
      convertConfirm: 'Anladım: disk yok edilecek',
      convertStarted: 'Dönüştürme başlatıldı — görev tamamlandığında şablon katalogda görünür.',
      storageLockHint: 'Depolama yalnızca Taşı eylemiyle değişir',
      source: 'Köken',
      sourceClone: 'Başka bir diskin klonu',
      sourceCloneLinked: "Başka bir diskin linked clone'u",
      sourceImage: 'Bir görüntüden oluşturuldu',
      sourceBlank: 'Boş oluşturuldu',
      allocated: 'Ayrılan / sanal boyut',
      observedAt: 'Gözlemlenme zamanı',
      snapshots: 'Anlık görüntüler',
      snapshotsEmpty: 'Anlık görüntü yok'
    },
    phase: {
      defined: 'Hiç açılmadı',
      starting: 'Başlatılıyor',
      running: 'Çalışıyor',
      stopping: 'Kapatılıyor',
      stopped: 'Kapalı',
      paused: 'Duraklatıldı',
      failed: 'Hatalı',
      deleting: 'Siliniyor'
    },
    stopCause: {
      'api': 'TVirt tarafından kapatıldı (eylem veya API)',
      'guest-shutdown': 'Kapatma konuk işletim sisteminden başlatıldı',
      'crash': 'Konuk çökmesi',
      'qemu-exit': 'QEMU süreci beklenmedik şekilde sonlandı',
      'host-reboot': 'Düğüm yeniden başlatıldı',
      'migrated': 'Başka bir düğüme geçirildi',
      'fenced': 'HA fencing tarafından sonlandırıldı (geri dönen düğüm)'
    },
    detail: {
      notFound: 'Sanal makine bulunamadı',
      details: 'Ayrıntılar',
      id: 'ID',
      scope: 'Scope',
      profile: 'Donanım profili',
      firmware: 'Firmware',
      firmwareFile: 'UEFI firmware sürümü',
      firmwareUpdate: 'Güncelleme mevcut',
      firmwareUpdateHint: "Platform daha yeni bir UEFI firmware'i sunuyor. Güncelleme asla otomatik değildir: VM kapalıyken, siz karar verdiğinizde uygulanır.",
      arch: 'Mimari',
      node: 'Düğüm',
      bootOrder: 'Önyükleme sırası',
      agent: 'Agent durumu',
      agentConnected: 'Bağlı',
      agentNotConnected: 'Bağlı değil',
      protected: 'Korumalı',
      linkedClones: 'Bağlı klonlar',
      restartPolicy: 'Yeniden başlatma ilkesi',
      preferredNode: 'Tercih edilen düğüm',
      noPreference: 'Tercih yok (otomatik placement)',
      preferNodes: 'Tercih edilen düğüm etiketleri',
      requireNodes: 'Zorunlu düğüm etiketleri',
      noPlacementTags: 'Yok',
      placementTag: 'Etiket',
      placementValue: 'Değer',
      placementAddTag: 'Etiket ekle',
      proximityHa: 'TVirt Proximity HA',
      proximityHaRestarts: 'HA yeniden başlatmaları',
      proximityHaGaveUp: 'crash loop — HA vazgeçti',
      failoverProtection: 'Bozulmuş kümede koruma',
      protectionProtected: 'Korumalı',
      protectionExpendable: 'Bozulmuşken gözden çıkarılabilir',
      protectionInherit: 'Devral',
      lastStop: 'Son kapanma',
      yes: 'Evet',
      no: 'Hayır',
      tabOverview: 'Genel bakış',
      tabSnapshots: 'Anlık görüntüler',
      tabBackups: 'Yedekler',
      hardware: 'Donanım',
      name: 'Ad',
      hwSystem: 'Sistem',
      hwCpu: 'CPU',
      hwMemory: 'Bellek',
      hwBoot: 'Önyükleme',
      hwIdentity: 'Kimlik',
      hwCluster: 'Küme ve agent',
      cpuTopology: 'CPU topolojisi',
      cpuModel: 'CPU modeli',
      cpuLimit: 'CPU sınırı',
      cpuWeight: 'CPU ağırlığı',
      cpuNested: "İç içe sanallaştırma",
      cpuNestedHint: "Konuğa vmx/svm sunar (yalnızca host CPU modeliyle). Çalışan bir VM'de değişiklik bir sonraki power cycle'da geçerli olur (PendingRestart); yerleştirme yalnızca nested etkin düğümleri kabul eder.",
      unlimited: 'Sınırsız',
      memory: 'Bellek',
      balloon: 'Balloon',
      hugePages: 'Büyük sayfalar',
      hugePagesTradeoff: 'Daha az adres çevirme işi ve asla diske gitmeyen bellek; karşılığında VM açık olduğu sürece rezerv düğümde kilitli kalır, bellek artık tekilleştirilmez ve düğümde yeterli boş sayfa yoksa başlatma başarısız olur.',
      disks: 'Diskler',
      cdroms: 'CD/DVD sürücüleri',
      nics: 'Ağ arabirimleri',
      slot: 'Slot',
      disk: 'Disk',
      encrypted: 'Şifreli',
      image: 'Görüntü',
      emptyDrive: 'Boş sürücü',
      emptyOption: '(boş)',
      network: 'Ağ',
      mac: 'MAC',
      connected: 'Takılı',
      unplugged: 'Takılı değil',
      noDevices: 'Yok',
      screenshot: 'Ekran görüntüsü',
      capturedAt: 'Yakalanma zamanı',
      noCapture: 'Henüz yakalama yok',
      snapshotName: 'Ad',
      snapshotCreated: 'Oluşturuldu',
      snapshotMemory: 'Bellek dahil',
      noSnapshots: 'Anlık görüntü yok',
      pendingRestart: "Bekleyen değişiklikler var: bir sonraki power cycle'da uygulanacak.",
      applied: 'uygulandı',
      appliedHint: "Çalışan VM bu değerle önyüklendi — yapılandırılan değer bir sonraki power cycle'da uygulanır.",
      actionError: 'Eylem başarısız',
      actionStillRunning: 'Eylem hâlâ devam ediyor: sonucu henüz bilinmiyor',
      tabConsole: 'Konsol',
      consoleConnect: 'Bağlan',
      consoleDisconnect: 'Bağlantıyı kes',
      consoleConnecting: 'Bağlanılıyor…',
      consoleReconnecting: 'Bağlanılıyor…',
      consoleUnavailable: 'Konsol, VM çalışırken veya duraklatılmışken kullanılabilir.',
      consoleError: 'Konsol bağlantısı başarısız',
      consoleTaken: 'Konsol oturumunu {user} devraldı',
      consoleReconnect: 'Yeniden bağlan',
      consoleCtrlAltDel: 'Ctrl+Alt+Del',
      consoleHold: '{key} tuşunu basılı tut',
      consoleFn: 'Fn…',
      consoleFullscreen: 'Yeni sekmede tam ekran aç',
      consoleLoadFailed: 'VM bulunamadı veya izinler yetersiz',
      consoleClose: 'Kapat',
      tabStats: 'İstatistikler',
      tabTasks: 'Görevler',
      tabLogs: 'Günlükler',
      statsCpu: 'CPU',
      statsMemory: 'Bellek',
      statsDisk: 'Disk I/O',
      statsRange: 'Aralık',
      statsNoData: 'Seçilen aralıkta veri yok — istatistikler VM çalışırken örneklenir.',
      statsError: 'İstatistikler yüklenemedi',
      cpuUsage: 'Kullanım',
      cpuReady: 'Ready (%RDY)',
      memUsed: 'Kullanılan',
      memGuestAvailable: 'Kullanılabilir (konuk)',
      schema: 'Şema',
      consoleProtocol: 'Konsol',
      agentEnabled: 'Guest agent',
      metadataStorage: 'Meta veri depolaması',
      startupOnBoot: 'Önyüklemede başlat',
      startupOrder: 'Başlatma sırası',
      startupDelay: 'Başlatma gecikmesi',
      seconds: 's',
      enabled: 'Etkin',
      disabled: 'Devre dışı'
    },
    actionsAvailable: 'Kullanılabilir eylemler',
    actions: {
      start: 'Başlat',
      stop: 'Kapat',
      pause: 'Duraklat',
      resume: 'Sürdür',
      reset: 'Sıfırla',
      migrate: 'Geçir',
      clone: 'Klonla',
      moveStorage: 'Depolamaya taşı…',
      moveScope: "Scope'a taşı…",
      openConsole: 'Konsolu aç',
      forceStop: 'Zorla kapat',
      markTemplate: 'Şablon olarak işaretle',
      unmarkTemplate: "VM'ye geri dönüştür",
      error: 'Eylem çalıştırılamadı'
    },
    cordon: {
      confirmTitle: 'Düğüm bakımda',
      confirmHint:
        'Küme store’u kapalıyken kordon indirilemez. Onaylayarak bunu bildiğinizi beyan edersiniz: VM yine de orada açılır ve onay görevde kayıtlı kalır.',
      confirm: 'Yine de aç'
    },
    markTemplate: {
      confirmTitle: "'{name}' şablon olarak işaretlensin mi?",
      confirmBody: "Yapılandırma dondurulur ve VM artık açılamaz — yalnızca klonlanabilir ya da VM'ye geri dönebilir. Ad, notlar ve etiketler düzenlenebilir kalır.",
      confirm: 'Şablon olarak işaretle',
      moved: '{name} artık bir şablon — Şablonlar sekmesine taşındı.'
    },
    unmarkTemplate: {
      confirmTitle: "'{name}' yeniden VM'ye dönüştürülsün mü?",
      confirmBody: 'Şablon yeniden sıradan bir VM olur: düzenlenebilir ve başlatılabilir (bir sonraki başlatma onu bir düğüme yerleştirir).',
      confirm: "VM'ye geri dönüştür",
      moved: '{name} yeniden bir sanal makine — Sanal makineler sekmesine taşındı.'
    },
    nodeByTag: {
      label: 'Düğüm etiketine göre',
      hint: "virgülle ayrılmış etiket=değer çiftleri (AND uygulanır): decider eşleşen düğümler arasından seçim yapar",
      invalid: 'Geçersiz biçim — virgülle ayrılmış etiket=değer kullanın',
      resolved: 'Eşleşen üyeler: {nodes}'
    },
    migrate: {
      title: 'Canlı geçiş',
      submit: 'Geçir',
      target: 'Hedef düğüm',
      auto: 'Otomatik (Proximity)',
      hint: 'VM, power cycle olmadan taşınır. Dokunduğu her depolama paylaşımlı olmalıdır; duraklatılmış bir VM duraklatılmış olarak geçer.',
      error: 'Geçiş reddedildi'
    },
    moveStorage: {
      title: 'Depolamaya taşı',
      submit: 'Taşı',
      target: 'Hedef depolama',
      noTargets: 'Hiçbir depolama disk kabul etmiyor',
      hint: "Kapalı VM'nin tüm diskleri, id'lerini koruyarak seçilen depolamaya tek tek taşınır — zaten orada olanlar atlanır. İlerleme görev sayfasından izlenir.",
      error: 'Depolama taşıması reddedildi'
    },
    moveScope: {
      title: "Scope'a taşı",
      submit: 'Taşı',
      target: 'Hedef scope',
      hint: "VM'nin scope'u hemen değişir — id ve diskler kalır, owned diskleri onu izler ve VM açık kalabilir. Şu anda {scope} içinde. Onu kimin gördüğü scope ile birlikte değişir.",
      error: 'Scope taşıması reddedildi'
    },
    start: {
      title: "VM'yi başlat",
      submit: 'Başlat',
      target: 'Hedef düğüm',
      auto: 'Otomatik (önerilen)',
      recommended: 'önerilen',
      hint: "Bir hedef düğüm seçin ya da geçerli adaylar arasından yerleştirmeyi Proximity'ye bırakın. VM'yi barındıramayan düğümler, nedeniyle birlikte devre dışı gösterilir.",
      error: 'VM başlatılamadı'
    },
    console: {
      media: 'CD/DVD sürücüleri',
      mediaGuestToolsHint: "TVirt Guest Tools'u içerir — buradan çıkarabilir veya sürücüyü kaldırabilirsiniz",
      slotOpsDeferred: "Bu profilde sürücü ekleme ve kaldırma bir sonraki power cycle'da uygulanır (ortam değişiklikleri anındadır).",
      mountGuestTools: "TVirt Guest Tools'u bağla",
      ejectGuestTools: "TVirt Guest Tools'u çıkar",
      bootOrder: 'Önyükleme sırası',
      bootOrderHint: "Yeni sıralama hemen kaydedilir ve bir sonraki power cycle'da uygulanır — konsol oturumu bağlı kalır."
    },
    snapshots: {
      create: 'Anlık görüntü oluştur',
      createTitle: 'Bir anlık görüntü oluştur',
      createSubmit: 'Oluştur',
      name: 'Ad',
      nameHint: 'Harf, rakam, nokta, tire, alt çizgi.',
      consistencyHint: 'Tutarlılık otomatiktir: guest agent yanıt verdiğinde dosya sistemlerini dondurur; aksi halde VM, anlık görüntü sırasında kısa süreliğine duraklatılır.',
      memory: 'Belleği dahil et',
      memoryHint: "Canlı RAM'i yakalar: geri yükleme VM'yi çalışır durumda sürdürür. Tüm disklerin qcow2 olmasını gerektirir.",
      currentChip: 'Buradasınız',
      revert: 'Geri yükle',
      revertTitle: "'{name}' anlık görüntüsüne geri yüklensin mi?",
      revertBody: "Diskler anlık görüntüdeki duruma döner; ondan sonra olan her şey kaybolur. Yalnızca disk içeren bir anlık görüntü, VM'nin durmuş olmasını gerektirir.",
      delete: 'Sil',
      deleteTitle: "'{name}' anlık görüntüsü silinsin mi?",
      deleteBody: 'Geri yükleme noktası kaybolur; disk içeriğine dokunulmaz.',
      deleteMergeHint: 'Deltası {children} içine birleştirilir: sonraki her geri yükleme noktası geçerli kalır.',
      deleteDuplication: 'Çoğaltmayı kabul ediyorum',
      deleteDuplicationHint: 'Delta, {count} okuyucunun her birine kopyalanır (alt snapshot’lar ve, bu geçerli olansa, etkin baş): kullanılan alan küçülmek yerine büyüyebilir.',
      error: 'Anlık görüntü işlemi reddedildi'
    },
    clone: {
      title: "VM'yi klonla",
      submit: 'Klonla',
      name: 'Kopyanın adı',
      storage: 'Diskler için hedef depolama',
      sameStorage: 'Kaynakla aynı',
      full: 'Tam kopya',
      fullHint: "Her baytı kopyalar ve kaynak disklerle bağı koparır. Varsayılan, linked clone'dur: anında, ama kaynağa zincirli (yalnızca qcow2).",
      hint: "Klon, kaynağın yapılandırmasını ve firmware'ini korur; MAC adresleri ve TPM kimliği yenidir.",
      markAs: 'Klon türü',
      markAsInheritVm: 'Kaynakla aynı (VM)',
      markAsInheritTemplate: 'Kaynakla aynı (şablon)',
      markAsVm: 'Sanal makine',
      markAsTemplate: 'Şablon',
      markAsHintVm: "Kopyayı tek adımda yükseltmek için Şablon'u seçin.",
      markAsHintTemplate: "Bu şablondan tek adımda dağıtmak için Sanal makine'yi seçin.",
      error: 'Klonlama reddedildi'
    },
    bulk: {
      selected: 'seçili',
      deleteTitle: {
        one: 'Seçili {count} VM silinsin mi?',
        other: 'Seçili {count} VM silinsin mi?'
      },
      deleteBody: 'Her VM, tekli silmedeki aynı korumalardan geçer; retler öğe başına raporlanır.',
      done: 'kabul edildi',
      refused: 'reddedildi'
    },
    delete: {
      button: 'Sil',
      confirmTitle: "'{name}' silinsin mi?",
      confirmBody: 'Sanal makine ve sahip olduğu diskler silinecek. Bu işlem geri alınamaz.',
      keepDisks: 'Diskleri koru',
      keepDisksHint: 'VM ile oluşturulan diskler, bağımsız diskler olarak kendi depolamalarında kalır.',
      confirm: 'Sil',
      cancel: 'İptal',
      error: 'Silme başarısız',
      blockedPhase: "Önce VM'yi kapatın",
      blockedProtected: 'VM korumalı — önce korumayı kaldırın',
      blockedDeleting: 'Silme zaten devam ediyor'
    },
    logs: {
      title: 'Günlükler',
      subtitle: "Bu VM'yi hedefleyen görevlerin yapılandırılmış günlük frame'leri",
      when: 'Ne zaman',
      task: 'Görev',
      level: 'Düzey',
      message: 'İleti',
      empty: 'Henüz günlük girdisi yok',
      loadError: 'Günlükler yüklenemedi — TVirt arka ucu erişilebilir mi?'
    },
    stop: {
      title: 'Sanal makineyi kapat',
      modeGraceful: 'Graceful kapatma',
      modeGracefulHint: 'Konuk işletim sisteminden düzgün biçimde kapanması istenir (ACPI); isteği yok sayarsa zaman aşımından sonra zorla kapatma devreye girer.',
      modeForced: 'Zorla kapatma',
      modeForcedHint: 'Gücü anında keser — fişi çekmek gibi.',
      timeout: 'Fallback zaman aşımı (saniye)',
      timeoutHint: 'Kapatma zorlanmadan önce konuğa tanınan bekleme süresi'
    },
    createFromScratch: 'Sıfırdan',
    createFromTemplate: 'Şablondan',
    createQuickDeploy: 'TVirt QuickDeploy',
    quickDeploy: {
      title: 'TVirt QuickDeploy',
      submit: 'Deploy\'u çalıştır',
      error: 'Deploy başarısız',
      compatNote: 'QuickDeploy, QuickDeploy ile uyumlu bir şablon gerektirir: platform ilk açılışta konuğu (ağ, etki alanı, etkinleştirme) özelleştirir.',
      template: 'Şablon',
      noTemplates: 'Henüz hiçbir şablon QuickDeploy uyumluluğu bildirmiyor — Şablonlar sekmesinden bildirin (cloud-init ile Linux, sysprep sonrası cloudbase-init ile Windows)',
      osLinux: 'Linux (cloud-init)',
      osWindows: 'Windows (cloudbase-init)',
      hostname: 'Ana bilgisayar adı',
      hostnameHint: 'Ana bilgisayar adı veya FQDN; boş = VM adı (Windows: en fazla 15 karakter)',
      ip: 'IP adresi',
      ipHint: 'Ana bilgisayar ve önek, örn. 192.168.122.101/24; boş = DHCP',
      gateway: 'Ağ geçidi',
      dns: 'DNS sunucuları',
      dnsHint: 'En fazla üç, virgülle ayrılmış',
      count: 'Örnekler',
      countHint: 'Birden fazla: <ad>-1…-N olarak adlandırılır, yalnızca DHCP',
      user: 'Kullanıcı',
      userHint: 'Boş = imajın varsayılan kullanıcısı (Linux) veya Administrator (Windows)',
      password: 'Parola',
      passwordHint: 'Üretilen user-data\'ya yazılır; platform bunu sonra gizli olarak bildirir: kimse bir daha okumaz',
      sshKeys: 'SSH ortak anahtarları',
      sshKeysHint: 'Satır başına bir tane (ssh-ed25519 AAAA… açıklama)',
      productKey: 'Windows ürün anahtarı',
      kmsServer: 'KMS sunucusu',
      kmsHint: 'Ana bilgisayar veya ana bilgisayar:port — ürün anahtarı gerektirir (KMS istemci anahtarı)',
      adDomain: 'Active Directory etki alanına katıl',
      adDomainHint: 'Boş = etki alanına katılım yok',
      adUser: 'Katılım hesabı',
      adPassword: 'Katılım hesabının parolası',
      adOu: 'Hedef OU (isteğe bağlı)',
      advanced: 'Gelişmiş: ham belgeler',
      userData: 'user-data (ham)',
      userDataHint: 'Üretilen user-data\'nın yerini alır: yukarıdaki kullanıcı, parola, anahtarlar ve Windows alanları boş kalmalıdır',
      networkConfig: 'network-config (ham)',
      networkConfigHint: 'Üretilen ağın yerini alır: yukarıdaki IP, ağ geçidi ve DNS boş kalmalıdır',
      secret: 'Ham user-data\'yı gizli say',
      secretHint: 'Gizli olarak işaretlendiğinde API onu artık kimseye döndürmez ve Checkpoint içinde masterpass ile mühürlenmiş olarak taşınır',
      startNow: 'Hemen başlat',
      startNowHint: 'Her örnek tanımlanır tanımlanmaz başlar; seed o başlatmada oluşturulur'
    },
    create: {
      nicAttachmentNetwork: 'Mantıksal ağ (fabric)',
      nicNetwork: 'Mantıksal ağ',
      nicNetworkHint: 'ÖNERİLEN yol (F3): vNIC, hizmet veren node\'un TÜRETİLMİŞ bridge\'inde gerçekleşir — bridge, fabric\'in açık apply\'ında doğar ve onu henüz taşımayan bir node\'da başlatma konuşarak reddeder. Filonun son referansı gittiğinde bridge bir sonraki apply\'da düşer.',
      button: 'VM oluştur',
      title: 'Sanal makine oluştur',
      dialogTitle: 'Sanal makine oluştur',
      stepGeneral: 'Genel',
      stepGeneralHint: 'Ad ve profil',
      stepCompute: 'CPU ve RAM',
      stepComputeHint: 'Topoloji ve boyutlandırma',
      stepDisks: 'Diskler',
      stepDisksHint: 'Oluştur veya tak',
      stepCdroms: 'CD/DVD',
      stepCdromsHint: 'Sürücüler ve ortamlar',
      stepNetwork: 'Ağ',
      stepNetworkHint: "NIC'ler: trunk veya köprü",
      stepSummary: 'Özet',
      stepSummaryHint: 'Gözden geçir ve oluştur',
      name: 'Ad',
      nameHint: 'Küçük harfler, rakamlar ve tireler (DNS-1123)',
      nextButton: 'İleri',
      prevButton: 'Geri',
      submitButton: 'Oluştur',
      creating: 'Oluşturuluyor…',
      sockets: 'Soket',
      cores: 'Soket başına çekirdek',
      threads: 'Çekirdek başına iş parçacığı',
      totalVcpus: 'Toplam vCPU',
      memoryGib: 'Bellek (GiB)',
      cpuModelHint: "'host', host CPU'sunu olduğu gibi sunar",
      cpuLimitHint: 'Host çekirdeği üst sınırı — boş = sınırsız',
      cpuNestedHint: "Konuğun kendi hipervizörünü çalıştırabilmesi için vmx/svm sunar — host CPU modeli ve nested etkin bir düğüm gerektirir",
      newDisk: 'Yeni disk',
      attachDisk: 'Var olan diski tak',
      diskStorage: 'Depolama',
      diskSize: 'Boyut (GiB)',
      diskSelect: 'Disk',
      addDisk: 'Disk ekle',
      addCdrom: 'CD/DVD sürücüsü ekle',
      addNic: 'Ağ arabirimi ekle',
      remove: 'Kaldır',
      slotLimit: 'Slot sınırına ulaşıldı',
      cdromImage: 'Görüntü (yoksa boş sürücü)',
      nicAttachment: 'Bağlantı',
      nicAttachmentTrunk: 'Overlay trunk',
      nicAttachmentBridge: 'Host köprüsü',
      nicUntagged: 'Untagged overlay',
      nicUntaggedNone: 'Yok (yalnızca tagged)',
      nicTrunkHint: "En az bir taraf: untagged bir overlay ve/veya tagged VLAN eşlemeleri — VM yalnızca başvurulan her overlay'in bildirdiği hostlarda çalışabilir",
      nicTaggedVlan: 'VLAN ID',
      nicTaggedOverlay: 'Overlay ağı',
      addTagged: 'Tagged VLAN ekle',
      nicBridge: 'Host köprüsünün adı',
      nicBridgeHint: 'Ada göre NM host köprüsü — VM yalnızca host ağı bu köprüyü bildiren sunucularda çalışabilir',
      nicMac: 'MAC (boşsa otomatik)',
      noDisksHint: 'Disk yok: VM yalnızca eklediğiniz CD/DVD sürücülerine sahip olacak.',
      noCdromsHint: 'CD/DVD sürücüsü yok: ISO görüntüsünden önyüklemek için bir tane ekleyin.',
      mountGuestTools: "İlk başlatmada TVirt Guest Tools'u bağla",
      mountGuestToolsHint: "virtio sürücüleri ile guest agent'ı içeren ISO'yu boş bir CD sürücüsüne yerleştirir (gerekirse sürücü eklenir) — Windows yükleyicisinin diskleri görebilmesi için bunlara ihtiyacı vardır.",
      noNicsHint: 'Ağ arabirimi yok: VM bağlantısız önyüklenecek.',
      taggedMappings: 'Tagged VLAN eşlemeleri',
      summaryDevices: 'Aygıtlar',
      bootOrderTitle: 'Önyükleme sırası',
      bootOrderHint: "Yeniden sıralamak için sürükleyin — önyüklenebilir ilk aygıt kazanır; NIC'ler PXE ile önyüklenir",
      bootOrderUp: 'Yukarı taşı',
      bootOrderDown: 'Aşağı taşı',
      createError: 'Oluşturma başarısız'
    },
    edit: {
      button: 'Düzenle',
      title: 'Sanal makineyi düzenle',
      cancel: 'İptal',
      save: 'Kaydet',
      error: 'Düzenleme başarısız',
      modelStoppedOnly: 'Yalnızca VM kapalıyken değiştirilebilir',
      firmwareStoppedOnly: 'Firmware yalnızca VM kapalıyken değiştirilebilir — bir sonraki başlatmada makine yeni firmware ile açılır ve UEFI değişkenleri korunur',
      hugePagesStoppedOnly: 'Yalnızca VM kapalıyken değiştirilebilir — bir sonraki başlatmada bellek yeni backing üzerinde oluşturulur',
      runningHint: "Değişiklikler bir sonraki power cycle'da uygulanır",
      sectionCpu: 'CPU',
      sectionMemory: 'Bellek',
      sectionPolicy: 'İlkeler'
    },
    devices: {
      networkChip: 'fabric ağı',
      title: 'Aygıtlar',
      usb: 'USB',
      gpu: 'GPU',
      addUsb: 'USB aygıtı ekle',
      addUsbTitle: 'Bir USB aygıt sınıfı iste',
      usbClassHint:
        'VM, belirli bir aygıt değil, bir USB aygıt SINIFI (bir usb-device etiketinin değeri) ister: başlatmada somut boş aygıt seçilir ve seçilen düğümde rezerve edilir. Kayıtlı aygıtları Küme › USB ve PCIe kaynakları altında etiketleyin.',
      usbTag: 'Etiket (usb-device)',
      usbValue: 'Sınıf değeri',
      noUsbTags: 'Henüz usb-device etiketi yok — bir tane oluşturun ve kayıtlı aygıtları Küme › USB ve PCIe kaynakları altında etiketleyin.',
      noUsbValues: 'Bu etiketin henüz bildirilen değeri yok.',
      usbEmpty: "USB gereksinimi yok — başlatmada bir aygıtı VM'ye geçirmek için bir sınıf ekleyin.",
      usbClassChip: 'sınıf',
      usbPortChip: 'port',
      usbUnclaimed: 'Rezerve edilmiş aygıt yok — VM başlatılırken çözülür.',
      addGpu: 'GPU ekle',
      addGpuTitle: 'Bir GPU sınıfı iste',
      gpuClassHint:
        "VM, belirli bir kart değil, bir GPU SINIFI (bir gpu-device etiketinin değeri) ister: başlatmada somut boş kart seçilip düğümde rezerve edilir ve TÜM IOMMU grubu BİRLİKTE geçirilir. Kayıtlı GPU'ları Küme › USB ve PCIe kaynakları altında etiketleyin.",
      gpuTag: 'Etiket (gpu-device)',
      gpuValue: 'Sınıf değeri',
      noGpuTags: "Henüz gpu-device etiketi yok — bir tane oluşturun ve kayıtlı GPU'ları Küme › USB ve PCIe kaynakları altında etiketleyin.",
      noGpuValues: 'Bu etiketin henüz bildirilen değeri yok.',
      gpuEmpty: "GPU gereksinimi yok — başlatmada bir kartı VM'ye geçirmek için bir sınıf ekleyin.",
      gpuClassChip: 'sınıf',
      gpuGroupChip: 'IOMMU grubu ×',
      gpuUnclaimed: 'Rezerve edilmiş kart yok — VM başlatılırken çözülür.',
      gpuPowerCycle: "GPU hotplug yok — değişiklikler bir sonraki power cycle'dan itibaren geçerlidir (PendingRestart)",
      actions: 'Eylemler',
      attachDisk: 'Disk ekle',
      attachDiskTitle: 'Bir disk ekle',
      attach: 'Tak',
      noFreeDisks: 'Kullanılmayan disk yok — Sanal makineler › Kullanılmayan diskler altında bir tane oluşturun.',
      addCdrom: 'Sürücü ekle',
      addCdromTitle: 'Bir CD/DVD sürücüsü ekle',
      editCdromTitle: 'CD/DVD görüntüsünü değiştir',
      changeMedia: 'CD/DVD görüntüsünü değiştir',
      ejectMedium: 'Çıkar',
      mountGuestTools: "TVirt Guest Tools'u bağla",
      guestToolsMounted: 'TVirt Guest Tools bağlı',
      guestToolsClickMount: "TVirt Guest Tools ISO'sunu ilk boş CD/DVD sürücüsüne yerleştirir",
      guestToolsClickUnmount: 'Çıkarmak için tıklayın — sürücü boş olarak kalır',
      guestToolsNoSlot: "Boş CD/DVD sürücüsü yok — TVirt Guest Tools'u bağlamak için bir sürücü ekleyin (veya bir ortamı çıkarın)",
      guestToolsSkew: 'Bağlı v{pinned}; {node} düğümü artık v{current} sunuyor: güncellemek için çıkarıp yeniden bağlayın',
      ejectGuestTools: "TVirt Guest Tools'u çıkar (sürücü boş olarak kalır)",
      guestToolsEjectConfirmTitle: 'TVirt Guest Tools çıkarılsın mı?',
      guestToolsEjectConfirmBody: "Ortam, açık VM'den çıkarılır — CD/DVD sürücüsü boş olarak kalır.",
      applyLive: 'Hemen uygula (VM açık)',
      addNic: 'Arabirim ekle',
      addNicTitle: 'Bir ağ arabirimi ekle',
      editNicTitle: 'Ağ arabirimini düzenle',
      bridgeChip: 'köprü',
      cable: 'Sanal kablo',
      plug: 'Sanal kabloyu tak',
      unplug: 'Sanal kabloyu çıkar',
      remove: 'Kaldır',
      removeTitle: '{device} kaldırılsın mı?',
      removeBody: "Açık bir VM'de değişiklik bir sonraki power cycle'da uygulanır. Diskler ve görüntüler yalnızca çıkarılır, asla silinmez."
    }
  }
}
